import axios from 'axios';
import React, { useState } from 'react';
import moment from "moment";
import NodataPic from "../../assets/Icon/Nodata.png";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";


function ScreenRecordShow({ roomId }) {

    const [bufferRecord, setBufferRecord] = useState(false);
    const [recordShow, setRecordShow] = useState(false)
    const [recoderData, setRecoderData] = useState([])

    const handelSaveScreenRecord = () => {
        setBufferRecord(true)
        axios.get("/api/sdk/meeting-record-download/" + roomId).then(res => {
            setBufferRecord(false)
            if (res.data.status == 200) {
                console.log('video list', res.data.saveVideo)
                setRecoderData(res.data.saveVideo)
                setRecordShow(true)
            }
        }).catch((err) => {
            setBufferRecord(false)
            console.log('error', err.message)
        });
    }


    return (
        <>
            {/* save video */}
            <div className="col-md-2 my-2 mb-4">
                <button className="btn btnEditTest w-100 fw-bold" onClick={() => bufferRecord ? null : handelSaveScreenRecord()}>
                    Show Records
                </button>
            </div>
            {bufferRecord &&
                <SkeletonTheme baseColor="#292929" highlightColor="#FFAA00" >
                    <Skeleton style={{ height: '10px', width: '100%', position: "absolute" }} />
                </SkeletonTheme>
            }
            {recordShow &&
                <div className="col-md-12 mb-3">
                    <div className="card card-bg solt-card">
                        <div className="card-body">
                            <h3 className="text-warning">
                                <i class="fa-solid fa-file-video" style={{ fontSize: '29px', padding: '8px' }}></i>
                                All Records ({recoderData.length})
                            </h3>
                            <div className="row my-3">

                                {recoderData.length != 0 ?
                                    <>
                                        {recoderData && recoderData.map((item, key) => (
                                            <div className="col-md-4 col-lg-2 mb-2 ">
                                                <p className="sold-small-card fw-bold text-ellipsis" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                                                    <i class="fa-solid fa-file-video" style={{ fontSize: '29px', padding: '8px' }}></i>

                                                    <div style={{ paddingTop: '5px' }}>
                                                        {moment(item?.updatedAt).format('ll')}
                                                        <p style={{ fontSize: '10px' }}>{moment(item?.updatedAt).format('LTS')}</p>
                                                    </div>

                                                    <a href={item?.file?.fileUrl} download style={{ textDecoration: 'none', marginRight: '10px', cursor: 'pointer' }}>download</a>
                                                </p>

                                            </div>
                                        ))}
                                    </>
                                    :
                                    <div >
                                        <img src={NodataPic} alt="" className="img-fluid" style={{ height: '150px' }} />
                                    </div>
                                }


                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default ScreenRecordShow